var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { class: ["dc-post-grid-card", "person-card"], attrs: { id: _vm.id } },
    [
      _c("div", { ref: "cardContentWrapper", staticClass: "content-wrapper" }, [
        _c("div", { staticClass: "content-wrapper__inner" }, [
          _vm.image
            ? _c("img", {
                attrs: {
                  src: _vm.image.src,
                  alt: _vm.image.alt,
                  srcset: _vm.image.srcset
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper__inner__person-info" }, [
            _c("div", [
              _c(
                "h2",
                { staticClass: "content-wrapper__inner__person-info__title" },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _vm._v(" "),
              _c(
                "h3",
                {
                  staticClass: "content-wrapper__inner__person-info__position"
                },
                [_vm._v(_vm._s(_vm.position))]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "content-wrapper__inner__person-info__phone no-line",
                  attrs: { href: "tel:" + _vm.email }
                },
                [_vm._v(_vm._s(_vm.phone))]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "content-wrapper__inner__person-info__email no-line",
                  attrs: { href: "mailto:" + _vm.email }
                },
                [_vm._v(_vm._s(_vm.email))]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-wrapper__bio-wrapper" }, [
          _c("p", { staticClass: "card-inner__bio-wrapper__bio" }, [
            _vm._v(_vm._s(_vm.bio))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }